export default __webpack_public_path__ + "static/KeywordResearch_02_03-71b1e91b4d5858927c000452d6174c84.png";